import {
  DialogContent,
  Dialog,
  DialogProps,
  DialogActions,
  Grid,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';
import { styled } from '@mui/styles';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { PmiButton } from 'shell/components/shared/button';
import PmiTextField from 'shell/components/shared/text-field';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { useParams } from 'react-router-dom';

export const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '50rem',
        maxWidth: '800px',
      },
}));

interface ModalUnavailabilityProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ModalUnavailability = ({
  open,
  onClose,
  onConfirm,
}: ModalUnavailabilityProps): React.ReactElement => {
  const params = useParams();
  const sendUnavailability = useHttpClient<void>(
    `${__PRACTICE_API_URL__}/registrazione-pratica-irricevibile/chiusura-bozza`,
    {
      options: {
        method: 'POST',
        loading: true,
        errorCatching: true,
      },
    }
  );

  const formContext = useFormik<{ reason: string }>({
    initialValues: {
      reason: '',
    },
    validationSchema: yup.object().shape({
      reason: yup.string().nullable().required('Campo obbligatorio'),
    }),
    onSubmit: (values) => {
      (
        sendUnavailability({
          data: {
            codiceEnte: params.codiceEnte,
            tipoRegistro: params.tipoRegistro,
            idAnnoPratica: params.idAnnoPratica,
            progressivoPratica: params.progressivoPratica,
            motivoChiusura: values.reason,
          },
        }) as ResponsePromise<void>
      ).then(() => {
        onConfirm();
      });
    },
  });

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      open={open}
      fullScreen={fullScreen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <PmiDialogTitle id="alert-dialog-title" backgroundColor="primary" color="white">
        Pratica Irricevibile
      </PmiDialogTitle>
      <DialogContent style={{ padding: '30px 24px' }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PmiTextField
              aria-label="Motivo irricicevibilità"
              label="Motivo irricicevibilità *"
              id="reason"
              name="reason"
              fullWidth
              minRows={5}
              multiline
              value={formContext.values?.reason || ''}
              onChange={formContext.handleChange}
              error={formContext.touched.reason && Boolean(formContext.errors.reason)}
              helperText={formContext.errors.reason}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <PmiButton variant="contained" color="primary" onClick={() => formContext.handleSubmit()}>
          Conferma
        </PmiButton>
        <PmiButton variant="outlined" color="cdmBrand" onClick={() => onClose()}>
          Annulla
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ModalUnavailability.displayName = 'Modal unavailability exception';

export default ModalUnavailability;
